export const dropDownTheme = theme => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary: '#E0B317',
    neutral20: '#444343',
    neutral30: 'black',
    neutral40: '#E0B317',
    neutral50: '#E0B317',
    neutral90: 'black',
  },
});

export const dropDownStyles = {
  container: styles => ({
    ...styles,
    gridArea: 'b',
    alignSelf: 'start',
  }),
  control: styles => ({
    ...styles,
    borderRadius: 0,
    cursor: 'pointer',
  }),
  valueContainer: provided => ({
    ...provided,
    height: '3rem',
  }),
  menu: provided => ({
    ...provided,
    marginTop: 5,
  }),
  menuList: styles => ({
    ...styles,
    padding: 0,
  }),
  option: (styles, state) => ({
    ...styles,
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: '300',
    color: '#444343',
    backgroundColor: state.isSelected ? '#E0B317' : null,
    cursor: 'pointer',
  }),
  singleValue: styles => ({
    ...styles,
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: '500',
    // color: '#E0B317',
  }),
  placeholder: styles => ({
    ...styles,
    fontFamily: 'Roboto',
    fontSize: '1rem',
    fontWeight: '300',
    color: '#444343',
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: 'none',
  }),
};
